import template from './invitationPositionDisplayBox.html';
import controller from './invitationPositionDisplayBox.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    position: '<',
    hideButton: '<'
  }
};

export default component;
